import { UpdateStreetComponent } from './update-street/update-street.component'
import { CreateStreetComponent } from './create-street/create-street.component'
import { StreetsComponent } from './streets.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const streetsRoutes: Routes = [
  {
    path: 'admin/streets',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'SYSTEM_MANAGEMENT_PANEL',
        redirectTo: '/',
      },
    },
    children: [
      {
        path: '',
        component: StreetsComponent,
        data: {
          permissions: {
            only: 'SYSTEM_MANAGEMENT_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: 'create',
        component: CreateStreetComponent,
        data: {
          permissions: {
            only: 'SYSTEM_MANAGEMENT_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id/update',
        component: UpdateStreetComponent,
        data: {
          permissions: {
            only: 'SYSTEM_MANAGEMENT_PANEL',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
